import i18n from '../i18n/i18n';

export function getRelativeTime(iso?: string) {
  if (!iso) return '';
  const diffMs = Date.now() - new Date(iso).getTime();
  if (diffMs < 0) return '';
  const mins = Math.floor(diffMs / 60000);
  if (mins < 1) return i18n.t('common.time.lessThanMinute');
  if (mins == 1) return i18n.t('common.time.minutes', { count: mins });
  if (mins < 60) return i18n.t('common.time.minutes_plural', { count: mins });
  const hours = Math.floor(mins / 60);
  if (hours == 1) return i18n.t('common.time.hours', { count: hours });
  if (hours < 24) return i18n.t('common.time.hours_plural', { count: hours });
  const days = Math.floor(hours / 24);
  if (days == 1) return i18n.t('common.time.days', { count: days });
  return i18n.t('common.time.days_plural', { count: days });
}

export default getRelativeTime;
